// Pathname → view routing for the storefront's few real URLs: the checkout return routes the
// payment providers redirect to (they must be actual paths — the SWA rewrites them to the SPA),
// the auth callback, and everything else (the shop shell). This is the tested logic unit;
// App.tsx just holds the result in state.

export type Route = 'shop' | 'purchase-success' | 'purchase-cancelled' | 'auth-callback';

/** The in-app tabs of the shop shell (purchase/callback routes render outside them). */
export type Tab = 'shop' | 'identity' | 'access';

export function routeFor(pathname: string): Route {
  switch (pathname) {
    case '/purchase/success':
      return 'purchase-success';
    case '/purchase/cancelled':
      return 'purchase-cancelled';
    case '/auth/callback':
      return 'auth-callback';
    default:
      return 'shop';
  }
}
